import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RejectFeedbackAnswerComponent from '../components/rejectFeedbackAnswerComponent';
import { getRejectFeedbackAnswerListFunc } from '../actions/viewFeedbackAnswerAction';

class RejectFeedbackAnswerContainer extends Component {
    
    componentDidMount() {
            this.props.actions.getRejectFeedbackAnswerListFunc(
            this.props.dispatch)
    }
    
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row"> 
                            <RejectFeedbackAnswerComponent
                                feedbackAnswerList={this.props.feedbackAnswerList}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getRejectFeedbackAnswerListFunc
        }, dispatch)
    };
};

function mapStateToProps({ viewFeedbackAnswerReducer}) {
    console.log(viewFeedbackAnswerReducer);
    return {
        feedbackAnswerList: {
            isLoading: viewFeedbackAnswerReducer.isLoading,
            answerList: viewFeedbackAnswerReducer.answerList,
            errorCode: viewFeedbackAnswerReducer.errorCode,
            messageLabel: viewFeedbackAnswerReducer.messageLabel,    
            statusCode: viewFeedbackAnswerReducer.statusCode
        },
        
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RejectFeedbackAnswerContainer))